import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import DocumentGroupingCriteriaContMain from "presentation/view/container/Criteria/DocumentGroupingCriteriaContMain";

CommonEntrypoint(<DocumentGroupingCriteriaContMain/>)